import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, MapPin, ArrowUpRight } from "lucide-react";

const LOGO_BADGE = "https://customer-assets.emergentagent.com/job_vet-impact-platform/artifacts/aj8j6qqi_Main.png";

const FOOTER_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Experiences", path: "/events" },
  { label: "Episodes", path: "/episodes" },
  { label: "Sponsor", path: "/sponsor-veteran" },
  { label: "Resources", path: "/resources" },
  { label: "Get Involved", path: "/get-involved" },
  { label: "Contact", path: "/contact" },
];

const SOCIAL_LINKS = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com/BadCompany_Entertainment" },
  { icon: Youtube, label: "YouTube", href: "https://youtube.com/@BadCompanyEntertainmentTV" },
  { icon: Mail, label: "Email", href: "mailto:BadCompanyEntertainmentco@gmail.com" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative bg-[#060e1a] border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="font-heading text-[12rem] sm:text-[18rem] lg:text-[24rem] uppercase text-white/[0.015] whitespace-nowrap leading-none">
          BAD COMPANY
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_BADGE} alt="Bad Company" className="h-16 w-16 object-contain" />
              <div>
                <span className="font-heading text-xl uppercase tracking-wider block leading-tight">Bad Company</span>
                <span className="font-body text-[9px] uppercase tracking-[0.25em] text-brand-gold block">Veterans Foundation</span>
              </div>
            </div>
            <p className="font-body text-slate-500 text-sm leading-relaxed max-w-xs">
              Connecting veterans, creating opportunities, and changing lives through community, entertainment, and purpose.
            </p>
            <div className="flex items-center gap-2 mt-6 text-slate-600">
              <MapPin size={14} />
              <span className="font-body text-xs uppercase tracking-wider">Las Vegas, Nevada</span>
            </div>
          </div>

          <div>
            <h4 className="font-subheading text-xs uppercase tracking-[0.2em] text-slate-500 mb-6">Navigation</h4>
            <div className="grid grid-cols-2 gap-3">
              {FOOTER_LINKS.map((link) => (
                <Link key={link.path} to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="font-body text-sm text-slate-400 hover:text-brand-gold transition-colors duration-300 flex items-center gap-1 group">
                  {link.label}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-subheading text-xs uppercase tracking-[0.2em] text-slate-500 mb-6">Connect</h4>
            <div className="space-y-4">
              {SOCIAL_LINKS.map((social) => (
                <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-400 hover:text-brand-gold transition-colors duration-300 group">
                  <social.icon size={18} />
                  <span className="font-body text-sm">{social.label}</span>
                </a>
              ))}
            </div>
            <div className="mt-8">
              <Link to="/get-involved" className="inline-block font-subheading text-xs uppercase tracking-widest btn-gold px-6 py-3">
                Become a Sponsor
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <p className="font-body text-xs text-slate-600">&copy; {new Date().getFullYear()} Bad Company Veterans Foundation. All rights reserved.</p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="font-subheading text-xs uppercase tracking-wider text-slate-600 hover:text-brand-gold transition-colors border border-slate-800 px-3 py-1">Admin</Link>
            <Link to="/scanner" data-testid="footer-scanner-link" className="font-subheading text-xs uppercase tracking-wider text-slate-600 hover:text-brand-gold transition-colors border border-slate-800 px-3 py-1">Scanner</Link>
          </div>
          <p className="font-body text-xs text-slate-700 text-center sm:text-right max-w-md">
            Currently in process of obtaining 501(c)(3) nonprofit status. Structured for transparency, accountability, and long-term impact.
          </p>
        </div>
      </div>
    </footer>
  );
}
